


// import React, { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// // import "./ClientmanagentDigitalMenu.css";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';

// const getDefaultClientDetailsRows = () => [
//     { key: "Owner Name", value: "", isUpload: false },
//     { key: "Business Plan", value: "", isUpload: false },
//     { key: "LOGO", value: null, isUpload: false },
//     { key: "Register Name", value: "", isUpload: false },
//     { key: "Register Documents", value: "", isUpload: true },
//     { key: "Phone No", value: "", isUpload: false },
//     { key: "Email ID", value: "", isUpload: false },
//     {
//         key: "Bank Details",
//         value: {
//             holderName: "",   // or accountHolderName if you prefer consistent naming
//             branchName: "",
//             accountNumber: "",
//             ifscCode: "",
//             passbook: null
//         },
//         isUpload: false,
//     },

//     { key: "AADHAR CARD NO", value: "", isUpload: false },
//     { key: "PAN CARD NO", value: "", isUpload: false },
//     { key: "Website", value: "", isUpload: false },
//     { key: "GST No.", value: "", isUpload: false },
// ];


// const STATUS_FIELD_MAP = {
//     "Business Plan": "businessPlanStatus",
//     "Company Name": "registeredNameStatus",
//     "Register Documents": "registeredDocumentsStatus",
//     "Owner Name": "ownerNameStatus",
//     "Business Vertical": "businessPlanStatus",
//     "Type": "typeStatus",
//     "Phone No": "mobileNumberStatus",
//     "Email ID": "emailStatus",
//     "AADHAR CARD NO": "aadharNumberStatus",
//     "PAN CARD NO": "panCardStatus",
//     "Website": "websiteNameStatus",
//     "GST No.": "gstNumberStatus",
//     "Trade License": "tradeLicenseStatus",
//     "FSSI License": "fssaiLicenseStatus",
//     "Labour License": "labourLicenseStatus",
// };

// /* ---------------- component ---------------- */
// const GroceryPaidClient = () => {
//     /* -------- list‑screen state -------- */
//     const [rolesData, setRolesData] = useState([]);
//     const [statusFilter, setStatusFilter] = useState("");
//     const [verticalFilter, setVerticalFilter] = useState("");
//     const [planFilter, setPlanFilter] = useState("");
//     const [filteredData, setFilteredData] = useState([]);
//     const { showLoader, hideLoader } = useLoader();
//     /* -------- detail‑screen state -------- */
//     const [selectedClient, setSelectedClient] = useState(null);
//     const [vendorDetails, setVendorDetails] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const [rows, setRows] = useState(getDefaultClientDetailsRows());
//     const [verifiedRows, setVerifiedRows] = useState([]);
//     const [rejectedRows, setRejectedRows] = useState([]);
//     const [isApproved, setIsApproved] = useState(false);

//     const fileInputRef = useRef(null);






//     const getDateField = (key, field) => {
//         const item = rows.find(r => r.key === key);
//         if (!item || !item.value) return null;
//         return item.value[field] && item.value[field] !== "N/A" ? item.value[field] : null;
//     };



//     const getBankField = (field) => {
//         const row = rows.find(r => r.key === "Bank Details");
//         if (!row || !row.value) return null;

//         // Send empty strings to API if field is empty
//         return row.value[field] !== undefined && row.value[field] !== null
//             ? row.value[field]
//             : null;
//     };



//     // Save row via API
//     const handleSaveRow = async () => {
//         const vendorId = getCurrentVendorId();
//         const token = localStorage.getItem("authToken");
//         if (!vendorId || !token) return alert("Vendor ID or token missing");

//         try {
//             // Helper: safely extract value from row
//             const getValue = (key) => {
//                 const item = rows.find((r) => r.key === key);
//                 if (!item) return null;
//                 let val = item.value;
//                 if (val === undefined || val === null || val === "N/A") return null;

//                 // Skip flattening for Bank Details
//                 if (key === "Bank Details") return val;

//                 if (typeof val === "object" && !Array.isArray(val)) {
//                     const flattened = Object.values(val)
//                         .filter((v) => v && v !== "N/A")
//                         .join(", ");
//                     return flattened || null;
//                 }

//                 return val;
//             };

//             // Build vendorData with all key fields
//             const vendorData = {
//                 registeredName: getValue("Registered Name"),
//                 ownerName: getValue("Owner Name"),
//                 mobileNumber: getValue("Phone No"),
//                 websiteName: getValue("Website"),
//                 email: getValue("Email ID"),
//                 aadharNumber: getValue("AADHAR CARD NO"),
//                 panCardNumber: getValue("PAN CARD NO"),
//                 tradeLicense: getValue("Trade License"),
//                 tradeLicenseStartDate: getDateField("Trade License", "startDate"),
//                 tradeLicenseEndDate: getDateField("Trade License", "endDate"),
//                 fssaiStartDate: getDateField("FSSI License", "startDate"),
//                 fssaiEndDate: getDateField("FSSI License", "endDate"),
//                 labourStartDate: getDateField("Labour License", "startDate"),
//                 labourEndDate: getDateField("Labour License", "endDate"),
//                 // 🏠 Flattened address
//                 addressLine: getValue("Address"),
//                 fullAddress: getValue("Full Address"),
//                 doorNumber: getValue("Door Number"),
//                 landMark: getValue("Landmark"),
//                 city: getValue("City"),
//                 state: getValue("State"),
//                 pincode: getValue("Pincode"),

//                 // 🌍 Coordinates
//                 latitude: parseFloat(getValue("Latitude")) || 0.0,
//                 longitude: parseFloat(getValue("Longitude")) || 0.0,

//                 // 🔢 Numeric and boolean fields
//                 averageDeliveryTime: parseInt(getValue("Average Delivery Time"), 10) || null,
//                 deliveryRadius: parseInt(getValue("Delivery Radius"), 10) || null,

//                 online: (() => {
//                     const val = getValue("Online");
//                     if (val === true || val === "true") return true;
//                     if (val === false || val === "false") return false;
//                     return null;
//                 })(),

//                 // 🏷️ Enum / Vendor Type
//                 vendorType: (() => {
//                     const val = getValue("Vendor Type");
//                     const validTypes = [
//                         "BAKERY",
//                         "HOTEL",
//                         "FOOD_COURT",
//                         "CAFE",
//                         "CLOUD_KITCHEN",
//                         "RESTAURANT",
//                         "STREET_FOOD",
//                     ];
//                     return validTypes.includes(val) ? val : null;
//                 })(),

//                 gstNumber: getValue("GST No."),
//                 fssaiNumber: getValue("FSSAI Number"),
//                 panNumber: getValue("PAN Number"),
//                 businessLicense: getValue("Business License"),
//                 upiId: getValue("UPI ID"),
//                 accountNumber: getBankField("accountNumber"),
//                 ifscCode: getBankField("ifscCode"),
//                 bankName: getBankField("branchName"),
//                 holderName: getBankField("holderName"),
//                 passbook: rows.find(r => r.key === "Bank Details")?.value?.passbook || null,

//                 aboutUs: getValue("About Us"),
//                 description: getValue("Description"),
//             };

//             // 🧹 Remove null keys
//             Object.keys(vendorData).forEach(
//                 (key) => vendorData[key] === null && delete vendorData[key]
//             );

//             // Debug preview
//             alert("📤 Sending vendorData:\n" + JSON.stringify(vendorData, null, 2));
//             // console.log("📤 Sending vendorData:", vendorData);


//             const formData = new FormData();
//             formData.append(
//                 "vendorData",
//                 new Blob([JSON.stringify(vendorData)], { type: "application/json" })
//             );

//             // Attach any selected images
//             // Attach any selected images & passbook
//             rows.forEach((row) => {
//                 // Regular images
//                 if (row.images?.length) {
//                     row.images.forEach((img, idx) => {
//                         if (img.file) formData.append(`image${idx + 1}`, img.file);
//                     });
//                 }

//                 // Bank Details passbook
//                 if (row.key === "Bank Details" && row.value?.passbook) {
//                     formData.append("passbook", row.value.passbook);
//                 }
//             });


//             // 🛰️ Send PUT API request
//             const res = await fetch(
//                 `https://backend.maamaas.com/subscription/api/vendors/edit/${vendorId}`,
//                 {
//                     method: "PUT",
//                     headers: {
//                         "Authorization": `Bearer ${token}`,
//                         "Accept": "application/json",
//                     },
//                     body: formData,
//                 }
//             );

//             const responseText = await res.text();
//             // console.log("📥 Response status:", res.status);
//             // console.log("📥 Response text:", responseText);

//             if (!res.ok) throw new Error(responseText);

//             alert("✅ All data saved successfully!");
//             await fetchVendorDetails(vendorId);
//         } catch (err) {
//             console.error("💥 Save all data error:", err);
//             alert("Error saving data: " + err.message);
//         }
//     };



//     /* ---------------- fetch list on mount ---------------- all the datadetails also not used in tha tg */
//     useEffect(() => {
//         const token = localStorage.getItem("authToken");
//         showLoader();
//         fetch("https://backend.maamaas.com/subscription/api/admin/get-all", {
//             headers: {
//                 "Content-Type": "application/json",
//                 "Authorization": `Bearer ${token}`
//             }
//         })
//             .then((res) => {
//                 if (!res.ok) throw new Error(`HTTP ${res.status}`);
//                 return res.json();
//             })
//             .then((data) => {
//                 const filtered = data.filter(item =>
//                     item.businessVerticals?.includes("FRESH_GROCERIES")
//                 );
//                 // console.log("Filtered payment data:", filtered);
//                 setRolesData(filtered);

//                 // ⬇️ Fetch vendor details for the first vendor (or loop through them)
//                 if (filtered.length > 0) {
//                     const vendorId = filtered[0]?.vendorId || filtered[0]?.vendor?.id;
//                     // console.log("Fetching vendor details for ID:", vendorId);
//                     if (vendorId) fetchVendorDetails(vendorId);
//                 }
//             })
//             .catch((err) => console.error("Payment fetch error:", err)).finally(() => {
//                 hideLoader();
//             })
//     }, []);




//     /* ---------------- filter whenever controls change ---------------- */
//     useEffect(() => {
//         let data = rolesData;
//         if (statusFilter) data = data.filter((i) => i.status === statusFilter);
//         if (verticalFilter) data = data.filter((i) => i.businessVertical === verticalFilter);
//         if (planFilter) data = data.filter((i) => i.businessPlan === planFilter);
//         setFilteredData(data);
//     }, [statusFilter, verticalFilter, planFilter, rolesData]);

//     /* ---------------- fetch vendor‑level details ---------------- */
//     // Fetch vendor details and map to rows
//     const fetchVendorDetails = async (vendorId) => {
//         if (!vendorId) return;
//         setLoading(true);
//         const token = localStorage.getItem("authToken");

//         try {
//             const res = await fetch(
//                 `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/get/${vendorId}`,
//                 {
//                     headers: { Authorization: `Bearer ${token}` },
//                 }
//             );

//             if (!res.ok) throw new Error(`HTTP ${res.status}`);
//             const data = await res.json();

//             // console.log("✅ Vendor details fetched:", data);

//             // Find image fields
//             const imageKeys = Object.keys(data).filter(
//                 (key) =>
//                     key.toLowerCase().includes("photo") ||
//                     key.toLowerCase().includes("image") ||
//                     key.toLowerCase().includes("license") ||
//                     key.toLowerCase().includes("logo") ||
//                     key.toLowerCase().includes("document") ||
//                     key.toLowerCase().includes("cheque") ||
//                     key.toLowerCase().includes("passbook")
//             );

//             const imageUrls = imageKeys
//                 .map((key) => data[key])
//                 .filter(
//                     (val) => val && typeof val === "string" && val.startsWith("http")
//                 );

//             // console.log("🖼️ Chicken Vendor Images:", imageUrls);

//             setRows(
//                 Object.keys(data).map((key) => ({
//                     key,
//                     value: data[key],
//                     isEditing: false,
//                     images: imageUrls.includes(data[key]) ? [data[key]] : [],
//                 }))
//             );
//             setVendorDetails(data);
//         } catch (err) {
//             console.error("❌ get-vendor-details error:", err);
//         } finally {
//             setLoading(false);
//         }
//     };




//     /* ---------------- build rows whenever selection or vendorDetails changes ---------------- */
//     useEffect(() => {
//         if (!selectedClient) {
//             setRows(getDefaultClientDetailsRows());
//             setVerifiedRows([]);
//             setRejectedRows([]);
//             setIsApproved(false);
//             return;
//         }

//         const merged = { ...selectedClient, ...(vendorDetails || {}) };

//         // 🖼️ Map keys to image fields (direct URLs)
//         const imageMap = {
//             "AADHAR CARD NO": [merged.aadharPhotoFront, merged.aadharPhotoBack],
//             "PAN CARD NO": [merged.panCard],
//             "Trade License": [merged.tradeLicense],
//             "FSSI License": [merged.fssaiLicense],
//             "Labour License": [merged.labourLicense],
//             "Bank Details": [merged.blankCheque, merged.passbook],
//             "Registered Documents": [
//                 merged.registeredDocumentsFront,
//                 merged.registeredDocumentsBack,
//             ],
//         };

//         // 🧾 Build table rows dynamically
//         const newRows = [
//             { key: "Owner Name", value: merged.ownerName || "N/A" },
//             { key: "Company Name", value: merged.registeredName || "N/A" },
//             { key: "Business Plan", value: merged.businessPlan || "N/A" },
//             { key: "Business Vertical", value: merged.businessVertical || "N/A" },
//             {
//                 key: "Order Type",
//                 value: Array.isArray(merged.orderTypes)
//                     ? merged.orderTypes
//                     : typeof merged.orderTypes === "string" && merged.orderTypes !== "N/A"
//                         ? merged.orderTypes.split(",").map((v) => v.trim())
//                         : [],
//             },
//             { key: "Website", value: merged.websiteName || "N/A" },
//             { key: "Phone No", value: merged.mobileNumber || "N/A" },
//             { key: "Email ID", value: merged.email || "N/A" },
//             {
//                 key: "Address",
//                 value: {
//                     doorNo: merged.doorNumber || "N/A",
//                     street: merged.addressLine || "N/A",
//                     city: merged.city || "N/A",
//                     state: merged.state || "N/A",
//                     pincode: merged.pincode || "N/A",
//                     landmark: merged.landMark || "N/A",
//                 },
//             },
//             { key: "AADHAR CARD NO", value: merged.aadharNumber || "N/A" },
//             { key: "PAN CARD NO", value: merged.panCardNumber || "N/A" },
//             {
//                 key: "Trade License",
//                 value: {
//                     startDate: merged.tradeLicenseStartDate || "N/A",
//                     endDate: merged.tradeLicenseEndDate || "N/A",
//                 },
//             },
//             {
//                 key: "FSSI License",
//                 value: {
//                     startDate: merged.fssaiStartDate || "N/A",
//                     endDate: merged.fssaiEndDate || "N/A",
//                 },
//             },
//             {
//                 key: "Labour License",
//                 value: {
//                     startDate: merged.labourStartDate || "N/A",
//                     endDate: merged.labourEndDate || "N/A",
//                 },
//             },
//             { key: "GST No.", value: merged.gstNumber || "N/A" },
//             {
//                 key: "Bank Details",
//                 value: {
//                     holderName: merged.holderName || merged.accountHolderName || "N/A",
//                     branchName: merged.branchName || merged.bankName || "N/A",
//                     accountNumber: merged.accountNumber || merged.accountNo || "N/A",
//                     ifscCode: merged.ifscCode || "N/A",
//                 },
//             },
//         ];

//         // ✅ Attach images (filter out nulls)
//         const updatedRows = newRows.map((row) => ({
//             ...row,
//             images: imageMap[row.key]?.filter(Boolean) || [],
//         }));

//         setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
//         setVerifiedRows([]);
//         setRejectedRows([]);
//         setIsApproved(false);
//     }, [selectedClient, vendorDetails]);

//     /* ---------------- helper: get vendorId from current selection ---------------- */
//     const getCurrentVendorId = () => {
//         return (
//             selectedClient?.vendorId ||
//             selectedClient?.vendorEnquiry?.vendorId ||
//             vendorDetails?.vendorId ||
//             null
//         );
//     };

//     /* ---------------- list‑row click ---------------- */
//     const handleViewClick = (client) => {
//         setSelectedClient(client);
//         const vendorId =
//             client?.vendorEnquiry?.vendorId || client.vendorId || client.vendorID;
//         fetchVendorDetails(vendorId);
//     };

//     /* ---------------- verify / reject handlers ---------------- */
//     const handleReject = async (i) => {
//         const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
//         const statusField = STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) {
//             // No mapping → mark locally
//             setRejectedRows(prev => (prev.includes(i) ? prev : [...prev, i]));
//             return;
//         }

//         const vendorId = getCurrentVendorId();
//         if (!vendorId) return alert("Vendor ID is missing – cannot update.");

//         const token = localStorage.getItem("authToken");
//         if (!token) return alert("Authorization token missing. Please log in.");

//         // ✅ Update UI immediately
//         setRejectedRows(prev => (prev.includes(i) ? prev : [...prev, i]));
//         if (statusField) setVendorDetails(prev => ({ ...(prev || {}), [statusField]: false }));

//         const url = `https://backend.maamaas.com/subscription/api/vendors/edit/${vendorId}`;

//         try {
//             const formData = new FormData();
//             formData.append(
//                 "vendorData",
//                 new Blob([JSON.stringify({ [statusField]: false })], { type: "application/json" })
//             );

//             if (vendorDetails?.images?.length) {
//                 vendorDetails.images.forEach((img, index) => {
//                     if (img.file) formData.append(`image${index + 1}`, img.file);
//                 });
//             }

//             const res = await fetch(url, {
//                 method: "PUT",
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                 },
//                 body: formData,
//             });

//             if (!res.ok) {
//                 const responseText = await res.text();
//                 let msg = responseText;
//                 try {
//                     const json = JSON.parse(responseText);
//                     msg = json.message || JSON.stringify(json);
//                 } catch { }
//                 throw new Error(msg || `HTTP ${res.status}`);
//             }

//             alert("Vendor status rejected successfully!");
//         } catch (err) {
//             console.error("status-update error:", err);
//             alert(`Failed to reject status: ${err.message}`);
//         }
//     };



//     // --- improved version ---
//     const handleVerifyy = async (i) => {
//         const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
//         const statusField = STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) {
//             setVerifiedRows(prev => (prev.includes(i) ? prev : [...prev, i]));
//             return;
//         }

//         const vendorId = getCurrentVendorId();
//         if (!vendorId) return alert("Vendor ID is missing – cannot update.");

//         const token = localStorage.getItem("authToken");
//         if (!token) return alert("Authorization token missing. Please log in.");

//         const url = `https://backend.maamaas.com/subscription/api/vendors/edit/${vendorId}`;

//         try {
//             const formData = new FormData();
//             formData.append(
//                 "vendorData",
//                 new Blob([JSON.stringify({ [statusField]: true })], { type: "application/json" })
//             );

//             // If you have images, append them as well
//             if (vendorDetails?.images?.length) {
//                 vendorDetails.images.forEach((img, index) => {
//                     if (img.file) formData.append(`image${index + 1}`, img.file);
//                 });
//             }

//             const res = await fetch(url, {
//                 method: "PUT",
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     // ✅ Do NOT set Content-Type manually for FormData!
//                 },
//                 body: formData,
//             });

//             const responseText = await res.text();

//             if (!res.ok) {
//                 let msg = responseText;
//                 try {
//                     const json = JSON.parse(responseText);
//                     msg = json.message || JSON.stringify(json);
//                 } catch { }
//                 throw new Error(msg || `HTTP ${res.status}`);
//             }

//             setVerifiedRows(prev => (prev.includes(i) ? prev : [...prev, i]));
//             setVendorDetails(prev => ({ ...(prev || {}), [statusField]: true }));
//             alert("Vendor data updated successfully!");
//         } catch (err) {
//             console.error("status-update error:", err);
//             alert(`Failed to update status: ${err.message}`);
//         }
//     };









//     /* ---------------- misc handlers ---------------- */
//     const handleBackClick = () => setSelectedClient(null);


//     const handleFileChange = (e, index) => {
//         const fileName = e.target.files[0]?.name || "";
//         const updated = [...rows];
//         updated[index].value = fileName;
//         setRows(updated);
//     };


//     /* ---------------- render ---------------- */
//     const registerDocIndex = rows.findIndex((r) => r.key === "Register Documents");



//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-12">

//                     < div
//                         className="client"
//                         style={{ overflowY: "auto", height: "500px" }}
//                     >
//                         {/* ------------------- LIST SCREEN ------------------- */}
//                         {!selectedClient ? (
//                             <>
//                                 {/* filters */}
//                                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                                     <div>


//                                     </div>
//                                     <div className="pe-3">

//                                     </div>
//                                 </div>

//                                 {/* table */}
//                                 <div className="sed pe-3">
//                                     <table style={tableStyle} className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th style={thStyle}>S.NO</th>
//                                                 <th style={thStyle}>Name</th>
//                                                 <th style={thStyle}>Email</th>
//                                                 <th style={thStyle}>Mobile</th>
//                                                 <th style={thStyle}>City</th>
//                                                 <th style={thStyle}>Vertical</th>

//                                                 <th style={thStyle}>Plan</th>
//                                                 <th style={thStyle}>Vendor Id</th>
//                                                 <th style={thStyle}>Payment Id</th>

//                                                 <th style={thStyle}>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {filteredData.length ? (
//                                                 filteredData.map((c, idx) => (
//                                                     <tr key={c.vendorId || idx}>
//                                                         <td style={thTdStyle}>{idx + 1}</td>
//                                                         <td style={thTdStyle}>{c?.vendorName || "—"}</td>
//                                                         <td style={thTdStyle}>{c?.email || "—"}</td>
//                                                         <td style={thTdStyle}>
//                                                             {c?.mobileNumber || "—"}
//                                                         </td>
//                                                         <td style={thTdStyle}>{c?.city || "—"}</td>
//                                                         <td style={thTdStyle}>
//                                                             {c?.businessVerticals || "—"}
//                                                         </td>

//                                                         <td style={thTdStyle}>
//                                                             {c?.planType || "—"}
//                                                         </td>
//                                                         <td style={thTdStyle}>{c?.vendorId || "—"}</td>
//                                                         <td style={thTdStyle}>{c?.id || "—"}</td>

//                                                         <td style={thTdStyle}>
//                                                             <button
//                                                                 style={{ ...buttonStyle, color: "#b15cd6", fontWeight: "bold" }}
//                                                                 onClick={() => handleViewClick(c)}
//                                                             >
//                                                                 View
//                                                             </button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td style={thTdStyle} colSpan={13}>
//                                                         No data available
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </>
//                         ) : (
//                             /* ------------------- DETAIL SCREEN ------------------- */
//                             <div className="mt-4 rounded-3 shadow-sm">
//                                 {/* header with back button */}
//                                 <div className="d-flex align-items-center mb-4">
//                                     <button
//                                         onClick={handleBackClick}
//                                         className="btn fw-bold px-4 py-2"
//                                         style={{ backgroundColor: "#b15cd6", color: "#fff" }}
//                                     >
//                                         Back to List
//                                     </button>

//                                 </div>

//                                 {loading && (
//                                     <div className="text-center my-4">
//                                         <span className="spinner-border text-primary" />
//                                     </div>
//                                 )}


//                                 {!loading && (
//                                     <div className="register mt-4">
//                                         <input
//                                             ref={fileInputRef}
//                                             type="file"
//                                             className="d-none"
//                                             onChange={(e) =>
//                                                 registerDocIndex !== -1 && handleFileChange(e, registerDocIndex)
//                                             }
//                                         />
//                                         <div className="registertable bo2">
//                                             <table className="table table-bordered table-striped align-middle mt-4 w-100">
//                                                 <thead>
//                                                     <tr>
//                                                         <th style={detailThStyle}>Field</th>
//                                                         <th style={detailThStyle}>Value</th>
//                                                         <th style={detailThStyle}>Image</th>
//                                                         <th style={detailThStyle}>Status</th>
//                                                     </tr>
//                                                 </thead>

//                                                 <tbody>
//                                                     {rows.map((r, i) => {
//                                                         const isEditing = r.isEditing || false;

//                                                         const handleInputChange = (field, value) => {
//                                                             setRows((prevRows) =>
//                                                                 prevRows.map((row, idx) =>
//                                                                     idx === i
//                                                                         ? {
//                                                                             ...row,
//                                                                             value:
//                                                                                 typeof row.value === "object"
//                                                                                     ? { ...row.value, [field]: value }
//                                                                                     : value,
//                                                                         }
//                                                                         : row
//                                                                 )
//                                                             );
//                                                         };

//                                                         const handleImageChange = (e) => {
//                                                             const files = Array.from(e.target.files);
//                                                             const newImages = files.map((file) => URL.createObjectURL(file));
//                                                             setRows((prevRows) =>
//                                                                 prevRows.map((row, idx) =>
//                                                                     idx === i ? { ...row, images: newImages } : row
//                                                                 )
//                                                             );
//                                                         };

//                                                         return (
//                                                             <tr key={r.key || i}>
//                                                                 {/* Field Name */}
//                                                                 <td className="fw-bold text-center align-middle">{r.key}</td>

//                                                                 {/* Editable Values */}
//                                                                 <td className="text-start align-middle">
//                                                                     {r.key === "Bank Details" ? (
//                                                                         ["holderName", "branchName", "accountNumber", "ifscCode"].map(
//                                                                             (field) => (
//                                                                                 <div key={field} className="mb-1">
//                                                                                     <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
//                                                                                     {isEditing ? (
//                                                                                         <input
//                                                                                             type="text"
//                                                                                             value={r.value?.[field] || ""}
//                                                                                             onChange={(e) =>
//                                                                                                 handleInputChange(field, e.target.value)
//                                                                                             }
//                                                                                             className="form-control d-inline-block w-75 ms-2"
//                                                                                         />
//                                                                                     ) : (
//                                                                                         r.value?.[field] || "N/A"
//                                                                                     )}
//                                                                                 </div>
//                                                                             )
//                                                                         )
//                                                                     ) : r.key === "Address" ? (
//                                                                         ["doorNo", "street", "city", "state", "pincode", "landmark"].map(
//                                                                             (field) => (
//                                                                                 <div key={field} className="mb-1">
//                                                                                     <strong>
//                                                                                         {field.charAt(0).toUpperCase() + field.slice(1)}:
//                                                                                     </strong>{" "}
//                                                                                     {isEditing ? (
//                                                                                         <input
//                                                                                             type="text"
//                                                                                             value={r.value?.[field] || ""}
//                                                                                             onChange={(e) =>
//                                                                                                 handleInputChange(field, e.target.value)
//                                                                                             }
//                                                                                             className="form-control d-inline-block w-75 ms-2"
//                                                                                         />
//                                                                                     ) : (
//                                                                                         r.value?.[field] || "N/A"
//                                                                                     )}
//                                                                                 </div>
//                                                                             )
//                                                                         )
//                                                                     ) : r.key.includes("License") ? (
//                                                                         <>
//                                                                             <div className="mb-2">
//                                                                                 <strong>Start Date:</strong>{" "}
//                                                                                 {isEditing ? (
//                                                                                     <input
//                                                                                         type="date"
//                                                                                         value={
//                                                                                             r.value?.startDate
//                                                                                                 ? new Date(r.value.startDate)
//                                                                                                     .toISOString()
//                                                                                                     .split("T")[0]
//                                                                                                 : ""
//                                                                                         }
//                                                                                         onChange={(e) =>
//                                                                                             handleInputChange("startDate", e.target.value)
//                                                                                         }
//                                                                                         className="form-control d-inline-block w-75 ms-2"
//                                                                                     />
//                                                                                 ) : r.value?.startDate ? (
//                                                                                     new Date(r.value.startDate).toLocaleDateString()
//                                                                                 ) : (
//                                                                                     "N/A"
//                                                                                 )}
//                                                                             </div>
//                                                                             <div>
//                                                                                 <strong>End Date:</strong>{" "}
//                                                                                 {isEditing ? (
//                                                                                     <input
//                                                                                         type="date"
//                                                                                         value={
//                                                                                             r.value?.endDate
//                                                                                                 ? new Date(r.value.endDate)
//                                                                                                     .toISOString()
//                                                                                                     .split("T")[0]
//                                                                                                 : ""
//                                                                                         }
//                                                                                         onChange={(e) =>
//                                                                                             handleInputChange("endDate", e.target.value)
//                                                                                         }
//                                                                                         className="form-control d-inline-block w-75 ms-2"
//                                                                                     />
//                                                                                 ) : r.value?.endDate ? (
//                                                                                     new Date(r.value.endDate).toLocaleDateString()
//                                                                                 ) : (
//                                                                                     "N/A"
//                                                                                 )}
//                                                                             </div>
//                                                                         </>
//                                                                     ) : (
//                                                                         <>
//                                                                             {isEditing ? (
//                                                                                 <input
//                                                                                     type="text"
//                                                                                     value={r.value || ""}
//                                                                                     onChange={(e) =>
//                                                                                         handleInputChange("value", e.target.value)
//                                                                                     }
//                                                                                     className="form-control d-inline-block w-75"
//                                                                                 />
//                                                                             ) : (
//                                                                                 r.value || "N/A"
//                                                                             )}
//                                                                         </>
//                                                                     )}
//                                                                 </td>

//                                                                 {/* Image Column */}
//                                                                 <td className="text-center align-middle">
//                                                                     {isEditing ? (
//                                                                         <>
//                                                                             <input
//                                                                                 type="file"
//                                                                                 multiple
//                                                                                 accept="image/*"
//                                                                                 onChange={handleImageChange}
//                                                                                 className="form-control mb-2"
//                                                                             />
//                                                                             <div className="d-flex justify-content-center gap-2 flex-wrap">
//                                                                                 {(r.images || []).map((img, idx) => (
//                                                                                     <img
//                                                                                         key={idx}
//                                                                                         src={img}
//                                                                                         alt={`${r.key}-${idx}`}
//                                                                                         style={{
//                                                                                             width: "70px",
//                                                                                             height: "70px",
//                                                                                             borderRadius: "8px",
//                                                                                             objectFit: "cover",
//                                                                                             border: "1px solid #ccc",
//                                                                                         }}
//                                                                                     />
//                                                                                 ))}
//                                                                             </div>
//                                                                         </>
//                                                                     ) : r.images && r.images.length > 0 ? (
//                                                                         <div className="d-flex justify-content-center gap-2 flex-wrap">
//                                                                             {r.images.map((img, idx) => (
//                                                                                 <img
//                                                                                     key={idx}
//                                                                                     src={img}
//                                                                                     alt={`${r.key}-${idx}`}
//                                                                                     style={{
//                                                                                         width: "70px",
//                                                                                         height: "70px",
//                                                                                         borderRadius: "8px",
//                                                                                         objectFit: "cover",
//                                                                                         border: "1px solid #ccc",
//                                                                                     }}
//                                                                                 />
//                                                                             ))}
//                                                                         </div>
//                                                                     ) : (
//                                                                         <span>No Image</span>
//                                                                     )}
//                                                                 </td>

//                                                                 {/* Status Buttons */}
//                                                                 <td className="text-center align-middle">
//                                                                     {isEditing ? (
//                                                                         <>
//                                                                             <button
//                                                                                 className="btn btn-sm btn-success me-2"
//                                                                                 style={{ minWidth: 80 }}
//                                                                                 onClick={() => handleSaveRow(i)}
//                                                                             >
//                                                                                 Save
//                                                                             </button>
//                                                                             <button
//                                                                                 className="btn btn-sm btn-secondary"
//                                                                                 style={{ minWidth: 80 }}
//                                                                                 onClick={() =>
//                                                                                     setRows((prev) =>
//                                                                                         prev.map((row, idx) =>
//                                                                                             idx === i ? { ...row, isEditing: false } : row
//                                                                                         )
//                                                                                     )
//                                                                                 }
//                                                                             >
//                                                                                 Cancel
//                                                                             </button>
//                                                                         </>
//                                                                     ) : (
//                                                                         <>
//                                                                             <button
//                                                                                 className={`btn btn-sm ${verifiedRows.includes(i) ? "btn-success" : "btn-warning"
//                                                                                     } me-2`}
//                                                                                 style={{ minWidth: 80 }}
//                                                                                 onClick={() => handleVerifyy(i)}
//                                                                                 disabled={
//                                                                                     verifiedRows.includes(i) || rejectedRows.includes(i)
//                                                                                 }
//                                                                             >
//                                                                                 {verifiedRows.includes(i) ? "Verified" : "Verify"}
//                                                                             </button>
//                                                                             <button
//                                                                                 className={`btn btn-sm ${rejectedRows.includes(i) ? "btn-danger" : "btn-secondary"
//                                                                                     } me-2`}
//                                                                                 style={{ minWidth: 80 }}
//                                                                                 onClick={() => handleReject(i)}
//                                                                                 disabled={
//                                                                                     rejectedRows.includes(i) || verifiedRows.includes(i)
//                                                                                 }
//                                                                             >
//                                                                                 {rejectedRows.includes(i) ? "Rejected" : "Reject"}
//                                                                             </button>
//                                                                             <button
//                                                                                 className="btn btn-sm btn-primary"
//                                                                                 style={{ minWidth: 80 }}
//                                                                                 onClick={() =>
//                                                                                     setRows((prev) =>
//                                                                                         prev.map((row, idx) =>
//                                                                                             idx === i ? { ...row, isEditing: true } : row
//                                                                                         )
//                                                                                     )
//                                                                                 }
//                                                                             >
//                                                                                 Edit
//                                                                             </button>
//                                                                         </>
//                                                                     )}
//                                                                 </td>
//                                                             </tr>
//                                                         );
//                                                     })}
//                                                 </tbody>
//                                             </table>




//                                             {/* <div className="d-flex justify-content-end mt-3 mb-5">
//                                                 {isEditing ? (
//                                                     <button className="btn btn-success" onClick={handleSaveClick}>
//                                                         Save
//                                                     </button>
//                                                 ) : (
//                                                     <button className="btn btn-primary" onClick={handleEditClick}>
//                                                         Edit
//                                                     </button>
//                                                 )}
//                                             </div> */}

//                                         </div>
//                                         {isApproved && (
//                                             <div className="d-flex flex-wrap bg-custom-purple text-white p-3 rounded mt-1 gap-4 mb-5">
//                                                 <h4>ClientID: {selectedClient?.vendorId || "N/A"}</h4>
//                                                 <h4>Plan: {selectedClient?.businessPlan || "N/A"}</h4>
//                                                 <h4>Status: Active</h4>
//                                                 <h4>Start Date: {selectedClient?.tradeLicenseStartDate || "N/A"}</h4>
//                                                 <h4>End Date: {selectedClient?.tradeLicenseEndDate || "N/A"}</h4>
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div >
//     );
// };

// /* ---------- badges &  inline styles ---------- */
// const getBadgeStyle = (isActive) => ({
//     display: "inline-block",
//     minWidth: 70,
//     padding: "1px 1px",
//     borderRadius: 4,
//     fontWeight: "bold",
//     color: "#fff",
//     textTransform: "uppercase",
//     backgroundColor: isActive ? "#28a745" : "#dc3545",
// });
// const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: 5 };
// const thTdStyle = { border: "1px solid #ddd", textAlign: "center" };
// const thStyle = { ...thTdStyle, backgroundColor: "#b15cd6", color: "#fff", fontWeight: "bold", maxWidth: "70px" };
// const buttonStyle = { backgroundColor: "transparent", border: "none", cursor: "pointer" };
// const selectStyle = { height: 35, marginTop: 20, marginRight: 10, borderRadius: 4, fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff" };
// const exportButtonStyle = { height: 35, marginTop: 20, borderRadius: 4, border: "none", backgroundColor: "#b15cd6", color: "#fff", fontWeight: "bold" };
// const detailThStyle = {
//     ...thTdStyle,
//     backgroundColor: "#b15cd6",
//     color: "#fff",                // white text
//     fontWeight: 600,              // slightly heavier than normal bold
//     padding: "0.75rem",           // ≈12 px (Bootstrap default)
//     verticalAlign: "middle",      // keep the text vertically centered
//     border: "1px solid #dee2e6",
//     textAlign: "center"
// };


// export default GroceryPaidClient;








import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const getDefaultClientDetailsRows = () => [
    { key: "Owner Name", value: "", isUpload: false },
    { key: "Business Plan", value: "", isUpload: false },
    { key: "LOGO", value: null, isUpload: false },
    { key: "Company Name", value: "", isUpload: false },
    { key: "Register Documents", value: "", isUpload: true },
    { key: "Phone No", value: "", isUpload: false },
    { key: "Email ID", value: "", isUpload: false },
    {
        key: "Bank Details",
        value: {
            holderName: "",
            branchName: "",
            accountNumber: "",
            ifscCode: "",
        },
        isUpload: false,
    },
    { key: "Passbook", value: "", isUpload: true },
    { key: "AADHAR CARD NO", value: "", isUpload: false },
    { key: "PAN CARD NO", value: "", isUpload: false },
    { key: "Website", value: "", isUpload: false },
    { key: "GST No.", value: "", isUpload: false },
];

const STATUS_FIELD_MAP = {
    "Owner Name": "ownerNameStatus",
    "Business Plan": "businessPlanStatus",
    "Company Name": "registeredNameStatus",
    "Register Documents": "registeredDocumentsStatus",
    "Phone No": "mobileNumberStatus",
    "Email ID": "emailStatus",
    "AADHAR CARD NO": "aadharNumberStatus",
    "PAN CARD NO": "panCardStatus",
    "Website": "websiteNameStatus",
    "GST No.": "gstNumberStatus",
    "Trade License": "tradeLicenseStatus",
    "FSSI License": "fssaiLicenseStatus",
    "Labour License": "labourLicenseStatus",
    "Bank Details": "bankDetailsStatus",
    "Passbook": "passbookStatus",
    "Address": "addressStatus",
    "LOGO": "logoStatus",
    "Order Type": "orderTypeStatus",
    "Business Vertical": "businessVerticalStatus",
};

// Order Type options
const orderTypeOptions = [
    "DINE_IN",
    "TAKEAWAY",
    "DELIVERY",
    "CATERING",
    "ALL"
];

// Business Plan options
const businessPlanOptions = [
    "HOTEL",
    "RESTAURANT",
    "CAFE",
    "CLOUD_KITCHEN",
    "FOOD_COURT",
    "STREET_FOOD",
    "BAKERY"
];

// Safe date conversion utility
const safeDateToISOString = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    return date.toISOString().split("T")[0];
};

// Safe date display utility
const safeDateDisplay = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";

    return date.toLocaleDateString();
};

// Add this function to check if a field has valid data
const hasValidData = (row, vendorDetails) => {
    if (!row || !vendorDetails) return false;

    const field = row.key;
    const value = row.value;

    // Check if the value exists and is not empty/"N/A"
    if (typeof value === 'string') {
        return value && value !== "N/A" && value.trim() !== "";
    }

    if (typeof value === 'object') {
        // For objects, check if any property has valid data
        return Object.values(value).some(val =>
            val && val !== "N/A" && val.toString().trim() !== ""
        );
    }

    return false;
};

// Update your isFieldVerified function to check both status AND data presence
const isFieldVerified = (rowKey, rowValue, vendorDetails) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];

    if (!statusField || !vendorDetails) return false;

    // If status is explicitly true, it's verified
    if (vendorDetails[statusField] === true) return true;

    // If status is null/undefined but field has valid data, consider it verified
    if ((vendorDetails[statusField] === null || vendorDetails[statusField] === undefined) &&
        hasValidData({ key: rowKey, value: rowValue }, vendorDetails)) {
        return true;
    }

    return false;
};

// Update your isFieldRejected function similarly
const isFieldRejected = (rowKey, vendorDetails) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];

    if (!statusField || !vendorDetails) return false;

    // Only return true if explicitly rejected (false)
    return vendorDetails[statusField] === false;
};

/* ---------------- component ---------------- */
const GroceryPaidClient = () => {
    /* -------- list‑screen state -------- */
    const [rolesData, setRolesData] = useState([]);
    const [statusFilter, setStatusFilter] = useState("");
    const [verticalFilter, setVerticalFilter] = useState("");
    const [planFilter, setPlanFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const { showLoader, hideLoader } = useLoader();
    /* -------- detail‑screen state -------- */
    const [selectedClient, setSelectedClient] = useState(null);
    const [vendorDetails, setVendorDetails] = useState(null);
    const [loading, setLoading] = useState(false);

    const [rows, setRows] = useState(getDefaultClientDetailsRows());
    const [verifiedRows, setVerifiedRows] = useState([]);
    const [rejectedRows, setRejectedRows] = useState([]);
    const [isApproved, setIsApproved] = useState(false);
    const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

    const fileInputRef = useRef(null);
    const [vendorData, setVendorData] = useState({});
    const [rowId, setRowId] = useState(null);

    const getCurrentVendorId = () => {
        return (
            selectedClient?.vendorId ||
            selectedClient?.vendorEnquiry?.vendorId ||
            vendorDetails?.vendorId ||
            null
        );
    };

    const vendorId = getCurrentVendorId();

    // Simple image error handler
    const handleImageError = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => new Set([...prev, errorKey]));
    };

    const handleImageLoad = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => {
            const newSet = new Set(prev);
            newSet.delete(errorKey);
            return newSet;
        });
    };

    const isImageFailed = (fieldName, index) => {
        return imageLoadErrors.has(`${fieldName}-${index}`);
    };

    const fetchVendorDetails = async (vendorId) => {
        if (!vendorId) return;
        setLoading(true);
        const token = localStorage.getItem("authToken");

        try {
            console.log(`🔍 FETCHING VENDOR DETAILS FOR ID: ${vendorId}`);

            const res = await fetch(
                `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            const data = await res.json();

            console.log("✅ API RESPONSE RECEIVED");
            setVendorDetails(data);

        } catch (err) {
            console.error("❌ get-vendor-details error:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveRow = async (rowIndex) => {
        const token = localStorage.getItem("authToken") || localStorage.getItem("token");

        if (!token) {
            alert("No authentication token found");
            return;
        }

        try {
            const vendorId = selectedClient?.vendorId;
            if (!vendorId) {
                console.error("Vendor ID not found");
                return;
            }

            const row = rows[rowIndex];
            console.log("Editing row:", row);

            // Create FormData
            const formData = new FormData();

            // 1. Append vendorData as JSON string (your backend expects this)
            const vendorData = {};

            // Map row keys to actual backend field names
            const fieldMapping = {
                "Owner Name": "ownerName",
                "Phone No": "mobileNumber",
                "Website": "websiteName",
                "Email ID": "email",
                "Company Name": "registeredName",
                "AADHAR CARD NO": "aadharNumber",
                "PAN CARD NO": "panCardNumber",
                "GST No.": "gstNumber",
                "Order Type": "orderTypes",
                "Business Plan": "businessPlan"
            };

            // Add the specific field being edited
            const backendFieldName = fieldMapping[row.key];
            if (backendFieldName && row.value) {
                if (row.key === "Order Type") {
                    // Handle array for order types
                    vendorData[backendFieldName] = Array.isArray(row.value) ? row.value : [row.value];
                } else if (row.value !== "N/A") {
                    vendorData[backendFieldName] = row.value;
                }
            }

            // Handle nested objects
            if (row.key === "Address" && typeof row.value === "object") {
                vendorData.doorNumber = row.value.doorNo !== "N/A" ? row.value.doorNo : "";
                vendorData.addressLine = row.value.street !== "N/A" ? row.value.street : "";
                vendorData.city = row.value.city !== "N/A" ? row.value.city : "";
                vendorData.state = row.value.state !== "N/A" ? row.value.state : "";
                vendorData.pincode = row.value.pincode !== "N/A" ? row.value.pincode : "";
                vendorData.landMark = row.value.landmark !== "N/A" ? row.value.landmark : "";
            }

            if (row.key === "Bank Details" && typeof row.value === "object") {
                vendorData.holderName = row.value.holderName !== "N/A" ? row.value.holderName : "";
                vendorData.branchName = row.value.branchName !== "N/A" ? row.value.branchName : "";
                vendorData.accountNumber = row.value.accountNumber !== "N/A" ? row.value.accountNumber : "";
                vendorData.ifscCode = row.value.ifscCode !== "N/A" ? row.value.ifscCode : "";
            }

            if (row.key.includes("License") && typeof row.value === "object") {
                if (row.key === "Trade License") {
                    vendorData.tradeLicenseStartDate = row.value.startDate !== "N/A" ? row.value.startDate : "";
                    vendorData.tradeLicenseEndDate = row.value.endDate !== "N/A" ? row.value.endDate : "";
                }
                if (row.key === "FSSI License") {
                    vendorData.fssaiStartDate = row.value.startDate !== "N/A" ? row.value.startDate : "";
                    vendorData.fssaiEndDate = row.value.endDate !== "N/A" ? row.value.endDate : "";
                }
                if (row.key === "Labour License") {
                    vendorData.labourStartDate = row.value.startDate !== "N/A" ? row.value.startDate : "";
                    vendorData.labourEndDate = row.value.endDate !== "N/A" ? row.value.endDate : "";
                }
            }

            // Append vendorData as JSON
            formData.append("vendorData", new Blob([JSON.stringify(vendorData)], {
                type: "application/json"
            }));

            // 2. Append images with proper field names
            if (row.images && row.images.length > 0) {
                row.images.forEach((img, idx) => {
                    if (img.file) {
                        const imageFieldName = getImageFieldName(row.key, idx);
                        formData.append(imageFieldName, img.file);
                        console.log(`Appending ${imageFieldName}:`, img.file.name);
                    }
                });
            }

            const response = await axios.put(
                `https://backend.maamaas.com/food/api/vendors/edit/${vendorId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("Update success:", response.data);
            alert("Data updated successfully!");

            setRows(prev =>
                prev.map((r, idx) => (idx === rowIndex ? { ...r, isEditing: false } : r))
            );

            fetchVendorDetails(vendorId);

        } catch (err) {
            console.error("Error updating vendor:", err);
            if (err.response?.status === 401) {
                alert("Authentication failed. Please check your token.");
            } else {
                alert("Error updating data: " + (err.response?.data?.message || err.message));
            }
        }
    };

    const getImageFieldName = (rowKey, imageIndex) => {
        const fieldMap = {
            "Register Documents": imageIndex === 0 ? "registeredDocumentsFront" : "registeredDocumentsBack",
            "AADHAR CARD NO": imageIndex === 0 ? "aadharPhotoFront" : "aadharPhotoBack",
            "PAN CARD NO": "panCard",
            "Trade License": "tradeLicense",
            "FSSI License": "fssaiLicense",
            "Labour License": "labourLicense",
            "Bank Details": "blankCheque",
            "Passbook": "passbook",
            "LOGO": "companyLogo",
        };

        return fieldMap[rowKey] || `image${imageIndex + 1}`;
    };

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        showLoader();
        fetch("https://backend.maamaas.com/subscription/api/admin/get-all", {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        })
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })
            .then((data) => {
                const filtered = data.filter(item =>
                    item.businessVerticals?.includes("FRESH_GROCERIES")
                );
                setRolesData(filtered);

                if (filtered.length > 0) {
                    const vendorId = filtered[0]?.vendorId || filtered[0]?.vendor?.id;
                    if (vendorId) fetchVendorDetails(vendorId);
                }
            })
            .catch((err) => console.error("Payment fetch error:", err)).finally(() => {
                hideLoader();
            })
    }, []);

    useEffect(() => {
        let data = rolesData;
        if (statusFilter) data = data.filter((i) => i.status === statusFilter);
        if (verticalFilter) data = data.filter((i) => i.businessVertical === verticalFilter);
        if (planFilter) data = data.filter((i) => i.businessPlan === planFilter);
        setFilteredData(data);
    }, [statusFilter, verticalFilter, planFilter, rolesData]);

    useEffect(() => {
        if (!selectedClient) {
            setRows(getDefaultClientDetailsRows());
            setVerifiedRows([]);
            setRejectedRows([]);
            setIsApproved(false);
            setImageLoadErrors(new Set());
            return;
        }

        const merged = { ...selectedClient, ...(vendorDetails || {}) };

        // REQUIRED Image mapping only
        const imageMap = {
            "Register Documents": [
                merged.registeredDocumentsFront,
                merged.registeredDocumentsBack
            ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "AADHAR CARD NO": [
                merged.aadharPhotoFront,
                merged.aadharPhotoBack
            ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "PAN CARD NO": [merged.panCard]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Trade License": [merged.tradeLicense]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "FSSI License": [merged.fssaiLicense]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Labour License": [merged.labourLicense]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Bank Details": [merged.blankCheque]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Passbook": [merged.passbook]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "LOGO": [merged.companyLogo]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
        };

        const newRows = [
            { key: "Owner Name", value: merged.ownerName || "N/A" },
            { key: "Company Name", value: merged.registeredName || "N/A" },
            { key: "LOGO", value: "Company Logo" },
            { key: "Business Plan", value: merged.businessPlan || "N/A" },
            { key: "Business Vertical", value: merged.businessVertical || "N/A" },
            {
                key: "Order Type",
                value: Array.isArray(merged.orderTypes)
                    ? merged.orderTypes
                    : typeof merged.orderTypes === "string" && merged.orderTypes !== "N/A"
                        ? merged.orderTypes.split(",").map((v) => v.trim())
                        : [],
            },
            { key: "Website", value: merged.websiteName || "N/A" },
            { key: "Phone No", value: merged.mobileNumber || "N/A" },
            { key: "Email ID", value: merged.email || "N/A" },
            {
                key: "Address",
                value: {
                    doorNo: merged.doorNumber || "N/A",
                    street: merged.addressLine || "N/A",
                    city: merged.city || "N/A",
                    state: merged.state || "N/A",
                    pincode: merged.pincode || "N/A",
                    landmark: merged.landMark || "N/A",
                },
            },
            { key: "Register Documents", value: "Registered Documents" },
            { key: "AADHAR CARD NO", value: merged.aadharNumber || "N/A" },
            { key: "PAN CARD NO", value: merged.panCardNumber || "N/A" },
            {
                key: "Trade License",
                value: {
                    startDate: merged.tradeLicenseStartDate || "N/A",
                    endDate: merged.tradeLicenseEndDate || "N/A",
                },
            },
            {
                key: "FSSI License",
                value: {
                    startDate: merged.fssaiStartDate || "N/A",
                    endDate: merged.fssaiEndDate || "N/A",
                },
            },
            {
                key: "Labour License",
                value: {
                    startDate: merged.labourStartDate || "N/A",
                    endDate: merged.labourEndDate || "N/A",
                },
            },
            { key: "GST No.", value: merged.gstNumber || "N/A" },
            {
                key: "Bank Details",
                value: {
                    holderName: merged.holderName || merged.accountHolderName || "N/A",
                    branchName: merged.branchName || merged.bankName || "N/A",
                    accountNumber: merged.accountNumber || merged.accountNo || "N/A",
                    ifscCode: merged.ifscCode || "N/A",
                },
            },
            { key: "Passbook", value: "Passbook Image" },
        ];

        const updatedRows = newRows.map((row) => ({
            ...row,
            images: imageMap[row.key] || [],
        }));

        setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
        setVerifiedRows([]);
        setRejectedRows([]);
        setIsApproved(false);
        setImageLoadErrors(new Set());
    }, [selectedClient, vendorDetails]);

    const handleViewClick = (client) => {
        console.log("👁️ VIEW CLICKED FOR CLIENT:", client);
        setSelectedClient(client);
        const vendorId = client?.vendorEnquiry?.vendorId || client.vendorId || client.vendorID;
        console.log("🔍 FETCHING VENDOR DETAILS FOR ID:", vendorId);
        fetchVendorDetails(vendorId);
    };

    const handleReject = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) {
            setRejectedRows(prev => (prev.includes(i) ? prev : [...prev, i]));
            return;
        }

        const vendorId = getCurrentVendorId();
        if (!vendorId) return alert("Vendor ID is missing – cannot update.");

        const token = localStorage.getItem("authToken");
        if (!token) return alert("Authorization token missing. Please log in.");

        const url = `https://backend.maamaas.com/food/api/vendors/edit/${vendorId}`;

        try {
            const formData = new FormData();
            const vendorData = {
                ...vendorDetails,
                [statusField]: false
            };

            formData.append(
                "vendorData",
                new Blob([JSON.stringify(vendorData)], { type: "application/json" })
            );

            if (vendorDetails?.images?.length) {
                vendorDetails.images.forEach((img, index) => {
                    if (img.file) formData.append(`image${index + 1}`, img.file);
                });
            }

            const res = await fetch(url, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
                body: formData,
            });

            const responseText = await res.text();
            console.log("❌ Reject API Response Status:", res.status);

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}`);
            }

            alert("Vendor status rejected successfully!");
        } catch (err) {
            console.error("❌ Reject error:", err);
            alert(`Failed to reject status: ${err.message}`);
        }
    };

    const handleVerifyy = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) {
            console.warn("No status mapping for:", rows[i].key);
            return;
        }

        const vendorId = getCurrentVendorId();
        if (!vendorId) return alert("Vendor ID is missing");

        const token = localStorage.getItem("authToken");
        if (!token) return alert("Authorization token missing");

        const url = `https://backend.maamaas.com/food/api/vendors/edit/${vendorId}`;

        try {
            const formData = new FormData();
            const currentStatus = vendorDetails?.[statusField];
            const newStatus = currentStatus === null ? true : true;

            const vendorData = {
                [statusField]: newStatus
            };

            formData.append(
                "vendorData",
                new Blob([JSON.stringify(vendorData)], { type: "application/json" })
            );

            const res = await fetch(url, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
                body: formData,
            });

            const responseText = await res.text();
            console.log("✅ Verify API Response Status:", res.status);

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}: ${responseText}`);
            }

            await fetchVendorDetails(vendorId);
            alert("Vendor data updated successfully!");
        } catch (err) {
            console.error("❌ Verify error:", err);
            alert(`Failed to update status: ${err.message}`);
        }
    };

    const handleBackClick = () => setSelectedClient(null);

    const handleFileChange = (e, index) => {
        const fileName = e.target.files[0]?.name || "";
        const updated = [...rows];
        updated[index].value = fileName;
        setRows(updated);
    };

    // Clean Image Display Component with "-" for missing images
    const ImageDisplay = ({ images, fieldName }) => {
        if (!images || images.length === 0) {
            return (
                <div className="text-center">
                    <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
                </div>
            );
        }

        return (
            <div className="d-flex justify-content-center gap-2 flex-wrap">
                {images.map((img, idx) => {
                    const imageUrl = typeof img === 'string' ? img : img.url;
                    const hasFailed = isImageFailed(fieldName, idx);

                    if (hasFailed || !imageUrl) {
                        return (
                            <div key={idx} className="text-center">
                                <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
                            </div>
                        );
                    }

                    return (
                        <div key={idx} className="text-center position-relative">
                            <img
                                src={imageUrl}
                                alt={`${fieldName}-${idx}`}
                                style={{
                                    width: fieldName === "LOGO" ? "80px" : "60px",
                                    height: fieldName === "LOGO" ? "80px" : "60px",
                                    borderRadius: "6px",
                                    objectFit: "cover",
                                    border: "1px solid #dee2e6",
                                }}
                                onError={() => handleImageError(imageUrl, fieldName, idx)}
                                onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12" style={{ marginTop: "10px" }}>
                    <div className="client" style={{ overflowY: "auto", height: "500px" }}>
                        {!selectedClient ? (
                            <>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div></div>
                                    <div className="pe-3"></div>
                                </div>

                                <div className="sed pe-3">
                                    <table style={tableStyle} className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={thStyle}>S.NO</th>
                                                <th style={thStyle}>Name</th>
                                                <th style={thStyle}>Email</th>
                                                <th style={thStyle}>Mobile</th>
                                                <th style={thStyle}>City</th>
                                                <th style={thStyle}>Vertical</th>
                                                <th style={thStyle}>Plan</th>
                                                <th style={thStyle}>Vendor Id</th>
                                                <th style={thStyle}>Payment Id</th>
                                                <th style={thStyle}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.length ? (
                                                filteredData.map((c, idx) => (
                                                    <tr key={c.vendorId || idx}>
                                                        <td style={thTdStyle}>{idx + 1}</td>
                                                        <td style={thTdStyle}>{c?.vendorName || "—"}</td>
                                                        <td style={thTdStyle}>{c?.email || "—"}</td>
                                                        <td style={thTdStyle}>{c?.mobileNumber || "—"}</td>
                                                        <td style={thTdStyle}>{c?.city || "—"}</td>
                                                        <td style={thTdStyle}>{c?.businessVertical || "—"}</td>
                                                        <td style={thTdStyle}>{c?.planType || "—"}</td>
                                                        <td style={thTdStyle}>{c?.vendorId || "—"}</td>
                                                        <td style={thTdStyle}>{c?.id || "—"}</td>
                                                        <td style={thTdStyle}>
                                                            <button
                                                                style={{ ...buttonStyle, color: "#b15cd6", fontWeight: "bold" }}
                                                                onClick={() => handleViewClick(c)}
                                                            >
                                                                View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td style={thTdStyle} colSpan={13}>
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        ) : (
                            <div className="mt-4 rounded-3 shadow-sm">
                                {/* <div className="d-flex align-items-center mb-4">
                                    <button
                                        onClick={handleBackClick}
                                        className="btn fw-bold px-4 py-2"
                                        style={{ backgroundColor: "#b15cd6", color: "#fff" }}
                                    >
                                        Back to List
                                    </button>
                                </div> */}

                                {loading && (
                                    <div className="text-center my-4">
                                        <span className="spinner-border text-primary" />
                                    </div>
                                )}

                                {!loading && (
                                    <div className="register mt-4">
                                        <div className="registertable bo2">
                                            <table className="table table-bordered table-striped align-middle mt-4 w-100">
                                                <thead>
                                                    <tr>
                                                        <th style={detailThStyle}>Field</th>
                                                        <th style={detailThStyle}>Value</th>
                                                        <th style={detailThStyle}>Image</th>
                                                        <th style={detailThStyle}>Status</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {rows.map((r, i) => {
                                                        const isEditing = r.isEditing || false;

                                                        const handleInputChange = (field, value) => {
                                                            setRows((prevRows) =>
                                                                prevRows.map((row, idx) =>
                                                                    idx === i
                                                                        ? {
                                                                            ...row,
                                                                            value:
                                                                                typeof row.value === "object"
                                                                                    ? { ...row.value, [field]: value }
                                                                                    : value,
                                                                        }
                                                                        : row
                                                                )
                                                            );
                                                        };

                                                        // Handle Order Type selection
                                                        const handleOrderTypeChange = (selectedValue) => {
                                                            setRows((prevRows) =>
                                                                prevRows.map((row, idx) =>
                                                                    idx === i
                                                                        ? {
                                                                            ...row,
                                                                            value: selectedValue,
                                                                        }
                                                                        : row
                                                                )
                                                            );
                                                        };

                                                        // Handle Business Plan selection
                                                        const handleBusinessPlanChange = (selectedValue) => {
                                                            setRows((prevRows) =>
                                                                prevRows.map((row, idx) =>
                                                                    idx === i
                                                                        ? {
                                                                            ...row,
                                                                            value: selectedValue,
                                                                        }
                                                                        : row
                                                                )
                                                            );
                                                        };

                                                        const handleImageChange = (e) => {
                                                            const files = Array.from(e.target.files);
                                                            const newImages = files.map((file) => ({
                                                                url: URL.createObjectURL(file),
                                                                file
                                                            }));

                                                            setRows(prev =>
                                                                prev.map((row, idx) =>
                                                                    idx === i
                                                                        ? {
                                                                            ...row,
                                                                            images: [...(row.images || []), ...newImages]
                                                                        }
                                                                        : row
                                                                )
                                                            );
                                                        };

                                                        return (
                                                            <tr key={r.key || i}>
                                                                <td className="fw-bold text-center align-middle">{r.key}</td>

                                                                <td className="text-start align-middle">
                                                                    {r.key === "Order Type" ? (
                                                                        isEditing ? (
                                                                            <select
                                                                                value={Array.isArray(r.value) ? r.value[0] : r.value}
                                                                                onChange={(e) => handleOrderTypeChange(e.target.value)}
                                                                                className="form-select w-75"
                                                                            >
                                                                                <option value="">Select Order Type</option>
                                                                                {orderTypeOptions.map((option) => (
                                                                                    <option key={option} value={option}>
                                                                                        {option}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        ) : (
                                                                            Array.isArray(r.value)
                                                                                ? r.value.join(", ")
                                                                                : r.value || "N/A"
                                                                        )
                                                                    ) : r.key === "Business Plan" ? (
                                                                        isEditing ? (
                                                                            <select
                                                                                value={r.value || ""}
                                                                                onChange={(e) => handleBusinessPlanChange(e.target.value)}
                                                                                className="form-select w-75"
                                                                            >
                                                                                <option value="">Select Business Plan</option>
                                                                                {businessPlanOptions.map((option) => (
                                                                                    <option key={option} value={option}>
                                                                                        {option}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        ) : (
                                                                            r.value || "N/A"
                                                                        )
                                                                    ) : r.key === "Bank Details" ? (
                                                                        ["holderName", "branchName", "accountNumber", "ifscCode"].map(
                                                                            (field) => (
                                                                                <div key={field} className="mb-1">
                                                                                    <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
                                                                                    {isEditing ? (
                                                                                        <input
                                                                                            type="text"
                                                                                            value={r.value?.[field] || ""}
                                                                                            onChange={(e) =>
                                                                                                handleInputChange(field, e.target.value)
                                                                                            }
                                                                                            className="form-control d-inline-block w-75 ms-2"
                                                                                        />
                                                                                    ) : (
                                                                                        r.value?.[field] || "N/A"
                                                                                    )}
                                                                                </div>
                                                                            )
                                                                        )
                                                                    ) : r.key === "Address" ? (
                                                                        ["doorNo", "street", "city", "state", "pincode", "landmark"].map(
                                                                            (field) => (
                                                                                <div key={field} className="mb-1">
                                                                                    <strong>
                                                                                        {field.charAt(0).toUpperCase() + field.slice(1)}:
                                                                                    </strong>{" "}
                                                                                    {isEditing ? (
                                                                                        <input
                                                                                            type="text"
                                                                                            value={r.value?.[field] || ""}
                                                                                            onChange={(e) =>
                                                                                                handleInputChange(field, e.target.value)
                                                                                            }
                                                                                            className="form-control d-inline-block w-75 ms-2"
                                                                                        />
                                                                                    ) : (
                                                                                        r.value?.[field] || "N/A"
                                                                                    )}
                                                                                </div>
                                                                            )
                                                                        )
                                                                    ) : r.key.includes("License") ? (
                                                                        <>
                                                                            <div className="mb-2">
                                                                                <strong>Start Date:</strong>{" "}
                                                                                {isEditing ? (
                                                                                    <input
                                                                                        type="date"
                                                                                        value={safeDateToISOString(r.value?.startDate)}
                                                                                        onChange={(e) =>
                                                                                            handleInputChange("startDate", e.target.value)
                                                                                        }
                                                                                        className="form-control d-inline-block w-75 ms-2"
                                                                                    />
                                                                                ) : (
                                                                                    safeDateDisplay(r.value?.startDate)
                                                                                )}
                                                                            </div>
                                                                            <div>
                                                                                <strong>End Date:</strong>{" "}
                                                                                {isEditing ? (
                                                                                    <input
                                                                                        type="date"
                                                                                        value={safeDateToISOString(r.value?.endDate)}
                                                                                        onChange={(e) =>
                                                                                            handleInputChange("endDate", e.target.value)
                                                                                        }
                                                                                        className="form-control d-inline-block w-75 ms-2"
                                                                                    />
                                                                                ) : (
                                                                                    safeDateDisplay(r.value?.endDate)
                                                                                )}
                                                                            </div>
                                                                        </>
                                                                    ) : r.key === "Register Documents" ? (
                                                                        "Registered Documents"
                                                                    ) : r.key === "Passbook" ? (
                                                                        "Passbook Image"
                                                                    ) : r.key === "LOGO" ? (
                                                                        "Company Logo"
                                                                    ) : (
                                                                        <>
                                                                            {isEditing ? (
                                                                                <input
                                                                                    type="text"
                                                                                    value={r.value || ""}
                                                                                    onChange={(e) =>
                                                                                        handleInputChange("value", e.target.value)
                                                                                    }
                                                                                    className="form-control d-inline-block w-75"
                                                                                />
                                                                            ) : (
                                                                                r.value || "N/A"
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </td>

                                                                <td className="text-center align-middle">
                                                                    {isEditing ? (
                                                                        <>
                                                                            <input
                                                                                type="file"
                                                                                multiple={r.key === "Register Documents" || r.key === "AADHAR CARD NO"}
                                                                                accept="image/*"
                                                                                onChange={handleImageChange}
                                                                                className="form-control mb-2"
                                                                            />
                                                                            <ImageDisplay images={r.images} fieldName={r.key} />
                                                                        </>
                                                                    ) : (
                                                                        <ImageDisplay images={r.images} fieldName={r.key} />
                                                                    )}
                                                                </td>

                                                                <td className="text-center align-middle">
                                                                    {isEditing ? (
                                                                        <>
                                                                            <button
                                                                                className="btn btn-sm btn-success me-2"
                                                                                style={{ minWidth: 80 }}
                                                                                onClick={() => handleSaveRow(i)}
                                                                            >
                                                                                Save
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-secondary"
                                                                                style={{ minWidth: 80 }}
                                                                                onClick={() =>
                                                                                    setRows((prev) =>
                                                                                        prev.map((row, idx) =>
                                                                                            idx === i ? { ...row, isEditing: false } : row
                                                                                        )
                                                                                    )
                                                                                }
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </>
                                                                    ) : (
                                                                        <div style={{ display: "flex", gap: "10px" }}>
                                                                            <button
                                                                                className={`btn btn-sm ${isFieldVerified(r.key, r.value, vendorDetails)
                                                                                    ? "btn-success"
                                                                                    : "btn-warning"
                                                                                    }`}
                                                                                style={{ minWidth: 80 }}
                                                                                onClick={() => handleVerifyy(i)}
                                                                                disabled={
                                                                                    isFieldVerified(r.key, r.value, vendorDetails) ||
                                                                                    isFieldRejected(r.key, vendorDetails)
                                                                                }
                                                                            >
                                                                                {isFieldVerified(r.key, r.value, vendorDetails) ? "Verified" : "Verify"}
                                                                            </button>

                                                                            <button
                                                                                className={`btn btn-sm ${isFieldRejected(r.key, vendorDetails) ? "btn-danger" : "btn-secondary"
                                                                                    }`}
                                                                                style={{ minWidth: 80 }}
                                                                                onClick={() => handleReject(i)}
                                                                                disabled={
                                                                                    isFieldRejected(r.key, vendorDetails) ||
                                                                                    isFieldVerified(r.key, r.value, vendorDetails)
                                                                                }
                                                                            >
                                                                                {isFieldRejected(r.key, vendorDetails) ? "Rejected" : "Reject"}
                                                                            </button>

                                                                            <button
                                                                                className="btn btn-sm btn-primary"
                                                                                style={{ minWidth: 80 }}
                                                                                onClick={() =>
                                                                                    setRows((prev) =>
                                                                                        prev.map((row, idx) =>
                                                                                            idx === i ? { ...row, isEditing: true } : row
                                                                                        )
                                                                                    )
                                                                                }
                                                                            >
                                                                                Edit
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: 5 };
const thTdStyle = { border: "1px solid #ddd", textAlign: "center" };
const thStyle = { ...thTdStyle, backgroundColor: "#b15cd6", color: "#fff", fontWeight: "bold", maxWidth: "70px" };
const buttonStyle = { backgroundColor: "transparent", border: "none", cursor: "pointer" };

const detailThStyle = {
    ...thTdStyle,
    backgroundColor: "#b15cd6",
    color: "#fff",
    fontWeight: 600,
    padding: "0.75rem",
    verticalAlign: "middle",
    border: "1px solid #dee2e6",
    textAlign: "center"
};

export default GroceryPaidClient;